import React, { useContext } from 'react';
import { object, string } from 'prop-types';
import { I18n } from '@fiverr-private/i18n-react';
import { Link, Text } from '@fiverr-private/typography';
import { Stack } from '@fiverr-private/layout_components';
import { NewBadge } from '@fiverr-private/badges';
import { EventsReportApiContext } from '../../utils/events';
import { LOGGED_OUT_HEADER_TYPE, LOGO_MAKER_LINK_KEY } from '../../shared/constants';

const ResourcesListItem = ({ link: { linkUrl, key, nofollow, withoutSource, isNew }, headerType }) => {
    const { reportBQ } = useContext(EventsReportApiContext);

    const rel = nofollow ? 'noopener nofollow' : 'noopener';
    const href = withoutSource ? linkUrl : `${linkUrl}?source=explore-tab`;

    const shouldHideLogoMaker = key === LOGO_MAKER_LINK_KEY && headerType !== LOGGED_OUT_HEADER_TYPE;

    const handleClick = (e) => {
        // Stop propagation to avoid triggering the parent’s redirect logic
        e.stopPropagation();
        reportBQ(`resources_tab::${key}`);
    };

    if (shouldHideLogoMaker) {
        return null;
    }

    return (
        <Link href={href} target="_blank" rel={rel} onClick={handleClick} decoration={{ hover: 'none' }}>
            <Stack gap="1.5" alignItems="center">
                <Text fontWeight="semibold" color="grey_1100">
                    <I18n k={`resources_tab.${key}.name`} />
                </Text>
                {isNew && <NewBadge />}
            </Stack>
            <Text color="grey_1000" size="b_sm">
                <I18n k={`resources_tab.${key}.caption`} />
            </Text>
        </Link>
    );
};

ResourcesListItem.propTypes = {
    link: object,
    headerType: string,
};

export default ResourcesListItem;
